import { RecordCircleIcon } from "@vericus/cadmus-icons";
import { Button, colors, Skeleton, Text } from "@vericus/cadmus-ui";

import { RecordingStartCutoffTip } from "@/features/socratic/components/recording-start-cutoff-tip";
import { useRecordingGate } from "@/features/socratic/hooks";

import * as styles from "./start-dialogue-cta.css";

type Props = {
  onStartPressed: () => void;
  loading?: boolean;
  isReadonly?: boolean;
  numAttemptsRemaining: number;
  hasPreparationTime?: boolean;
};

export function StartDialogueCTA({
  onStartPressed,
  loading = false,
  isReadonly = false,
  numAttemptsRemaining,
  hasPreparationTime = false,
}: Props) {
  const { hasAutoSubmission, wouldAutoSubmitDuringRecording } =
    useRecordingGate();

  const hasAttemptsRemaining = numAttemptsRemaining > 0;

  const startDisabled =
    loading ||
    isReadonly ||
    wouldAutoSubmitDuringRecording ||
    !hasAttemptsRemaining;

  return (
    <div className={styles.box}>
      <div className={styles.main}>
        {hasAttemptsRemaining && (
          <Text kind="bodyMd" color="navy700">
            {`Click "Start Response" to begin. `}
            {hasPreparationTime
              ? "Preparation time will start immediately."
              : "Response time will start immediately."}
          </Text>
        )}
        <Button
          kind="secondary"
          icon={
            <RecordCircleIcon
              label=""
              size={24}
              color={startDisabled ? colors.sgrey400 : colors.poppy500}
            />
          }
          onClick={onStartPressed}
          disabled={startDisabled}
        >
          START RESPONSE
        </Button>
      </div>
      {!isReadonly && hasAttemptsRemaining && (
        <RecordingStartCutoffTip
          isFirstAttempt
          hasAutoSubmission={hasAutoSubmission}
        />
      )}
    </div>
  );
}

export function StartDialogueCTASkeleton() {
  return <Skeleton width={14.5} height={40} />;
}
